(() => {
  const baseClass = 'swinger-availability-indicator';

  window.swinger.observer.initialize(`.${baseClass}[data-itemnumber]`, (elem) => {
    const itemNumber = elem.getAttribute('data-itemnumber');
    const baseUrl = `${window.swinger.config.apiBase}${window.swinger.config.apiRoutes.contentMovies}`;
    const itemUrl = `${baseUrl}?idList[]=${encodeURIComponent(itemNumber)}`;

    Promise.all([
      window.swinger.i18n(),
      window.swinger.ajax(itemUrl),
    ])
      .then((results) => {
        const { 0: i18n, 1: result } = results;
        let availabilityStatus = 'available';

        if (!result || !result[0] || typeof result[0].availability === 'undefined') {
          return;
        }

        const numericStatus = `${result[0].availability}`;

        switch (numericStatus) {
          default:
            break;

          case '0':
            availabilityStatus = 'unavailable';
            break;

          case '1':
            availabilityStatus = 'available';
            break;

          case '2':
            availabilityStatus = 'backorder';
            break;
        }

        const text = i18n(`ui.availability-indicator.${availabilityStatus}`);

        elem.setAttribute('aria-label', text);
        elem.textContent = text;
        elem.classList.toggle(`${baseClass}--unavailable`, numericStatus === '0');
        elem.classList.toggle(`${baseClass}--available`, numericStatus === '1');
        elem.classList.toggle(`${baseClass}--backorder`, numericStatus === '2');
      })
      .catch(console.info);
  }, false);
})();
